/**
 * Embedded proto vehicle group.
 */
export class VehicleGroupDto {
  uuid!: string;
  name!: string;
}
